module.exports = __webpack_public_path__ + "static/img/superior.7bfe72ce.png";